/**
 * ひらがなをカタカナに変換するユーティリティ関数
 * 薬品検索など、カタカナで登録されているデータの検索に使用
 */

/**
 * ひらがなをカタカナに変換
 * @param {string} str - 変換対象の文字列
 * @returns {string} カタカナに変換された文字列
 */
export const hiraganaToKatakana = (str) => {
  if (!str) return str;
  
  return str.replace(/[\u3041-\u3096]/g, (match) => {
    const chr = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(chr);
  });
};

/**
 * カタカナをひらがなに変換（参考用、現在未使用）
 * @param {string} str - 変換対象の文字列
 * @returns {string} ひらがなに変換された文字列
 */
export const katakanaToHiragana = (str) => {
  if (!str) return str;
  
  return str.replace(/[\u30a1-\u30f6]/g, (match) => {
    const chr = match.charCodeAt(0) - 0x60;
    return String.fromCharCode(chr);
  });
};

// 使用例:
// hiraganaToKatakana('あすぴりん') => 'アスピリン'
// hiraganaToKatakana('ろきそにん') => 'ロキソニン'
// hiraganaToKatakana('ガスター10mg') => 'ガスター10mg' (既にカタカナの部分はそのまま)

